import { Trait } from "types";
import * as traitsApi from "api/traitsApi";
import useFetchPromise from "hooks/useFetchPromise";

const useFetchTraits = () =>
  useFetchPromise<Trait[], boolean>(traitsApi.fetchTraits, true);

export default useFetchTraits;
